var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['dragger', { 'is-draggable': _vm.isDraggable, 'is-dragging': _vm.isDragging }],on:{"mouseenter":_vm.init,"mousedown":_vm.start,"wheel":_vm.scroll}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }